import { useState, ChangeEvent } from 'react'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { checkoutDeliveryOrder } from 'actions/orders.action'
import IDeliveryOrder, { CartItem } from 'models/IDeliveryOrder'

export interface CheckoutFormProps {
  isLoading: boolean
  restaurantName?: string
  cartItems: CartItem[] | null
}

export interface OrderForm {
  customerName: string
  phoneNumber: string
  location: string
  notes: string
}

export const useCheckoutForm = (props: CheckoutFormProps) => {
  const { cartItems, restaurantName } = props

  const [formData, setFormData] = useState<OrderForm>({
    customerName: '',
    phoneNumber: '',
    location: '',
    notes: '',
  })

  const dispatch = useAppDispatch()

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target

    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const { customerName, phoneNumber, location, notes } = formData

    if (restaurantName && cartItems && cartItems.length > 0) {
      const deliveryOrder: IDeliveryOrder = {
        slug: restaurantName,
        customerInfo: {
          name: customerName,
          phone: phoneNumber,
          location,
          notes,
        },
        cart: cartItems,
      }

      dispatch(checkoutDeliveryOrder(deliveryOrder))
    }
  }
  return {
    ...props,
    formData,
    handleInputChange,
    handleSubmit,
  }
}
